import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { computed } from 'vue';
import VariationList from './VariationList.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PillVariation',
  props: {
    variations: {},
    preselectedVariation: {},
    disabled: { type: Boolean }
  },
  emits: ['set-variation', 'variation-dropdown-opened'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

const selectedVariationLabel = computed(() => {
  return props.variations.find(
    (v) => v.id === props.preselectedVariation || v.label === props.preselectedVariation
  )?.label;
});

const setVariation = (variation: { id: string; label: string }, hideFn: Function) => {
  if (typeof hideFn === 'function') hideFn();
  emits('set-variation', variation);
};

const onTippyShow = () => {
  if (props.variations.length <= 1 || props.disabled) return false;
  emits('variation-dropdown-opened');
};

return (_ctx: any,_cache: any) => {
  const _component_v_popover = _resolveComponent("v-popover")!

  return (_openBlock(), _createBlock(_component_v_popover, {
    interactive: "",
    tag: "div",
    "content-tag": "div",
    role: 'poper',
    trigger: 'click',
    "on-show": onTippyShow
  }, {
    default: _withCtx(({ state }) => [
      _createElementVNode("div", {
        ref: "variationButton",
        class: _normalizeClass(["filter-variation usn pill-segment", {
          pt: _ctx.variations.length > 1 && !_ctx.disabled,
          opn: state.isVisible && _ctx.variations.length > 1 && !_ctx.disabled,
          'no-chng': _ctx.variations.length <= 1 || _ctx.disabled,
        }])
      }, [
        _createElementVNode("div", null, _toDisplayString(selectedVariationLabel.value), 1)
      ], 2)
    ]),
    content: _withCtx(({ state, hide }) => [
      (state.isVisible)
        ? (_openBlock(), _createBlock(VariationList, {
            key: 0,
            variations: _ctx.variations,
            onSetVariation: ($event: any) => (setVariation($event, hide)),
            onVariationDropdownOpened: onTippyShow
          }, null, 8, ["variations", "onSetVariation"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})